import React, { useEffect, useState } from 'react';
import { message, Button, Card, Layout, Typography, Radio, Space, Row, Col, Divider } from 'antd';
import env from '../../../environment';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import numeral from 'numeral';
import { ArrowLeftOutlined, LockOutlined } from '@ant-design/icons';
import { Footer } from 'antd/es/layout/layout';

const protectedPayment = require('../../../assets/icons/protectedPayment.png');
import CheckOutComponent from '../../ProductsImo/CheckOutComponent';

const { Text } = Typography;

function Payments({}) {
	const { t } = useTranslation();
	const userToken = useSelector((state: any) => state.auth.token);
	const [valueRadio, setValueRadio] = useState(1);
	const { operationId } = useParams();
	const navigate = useNavigate();
	const [showCheckout, setShowCheckout] = useState(false);
	const [dataClient, setDataClient] = useState<any>('');
	const [mortgage, setMortgage] = useState<any>(undefined);

	const backToDocuments = () => {
		navigate(`/operations/${operationId}/documents`);
	};

	useEffect(() => {
		getTokenPay();
		getDataOperation();
	}, []);

	const getDataOperation = () => {
		axios
			.get(`${env.api.url}/v1/operations/${operationId}`, {
				headers: { Authorization: `Bearer ${userToken}` }
			})
			.then((response) => {
				setMortgage(response.data.data);
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const getTokenPay = () => {
		axios
			.post(
				`${env.api.url}/v1/payments/appraisal/checkout`,
				{
					operationId: operationId
				},
				{
					headers: { Authorization: `Bearer ${userToken}` }
				}
			)
			.then((response) => {
				setDataClient(response.data.data);
			})
			.catch((e) => {
				console.log(e);
			});
	};

	return (
		<Layout style={{ padding: 16, marginTop: 24, marginBottom: 200 }}>
			<Space
				onClick={() => backToDocuments()}
				style={{ color: '#2F4858', fontSize: 16, cursor: 'pointer' }}>
				<ArrowLeftOutlined />
				<Text style={{ fontSize: 16, fontWeight: 600, color: '#2F4858' }}>
					{t('viability.back')}
				</Text>
			</Space>
			<div style={{ marginTop: 16 }}>
				<Text style={{ fontSize: 16, fontWeight: 600, color: '#2F4858', marginTop: 16 }}>
					{t('payments.pending')}
				</Text>
			</div>
			{/*<div style={{ marginBottom: -10 }}>
				<Divider type="horizontal" style={{ color: '#C0DAEE' }}></Divider>
			</div>*/}

			{/*(
				<Row style={{ marginTop: 0 }}>
					<Col span={12} style={{ display: 'flex', flexDirection: 'column' }}>
						<Text style={{ color: '#748EA0', fontSize: 14, fontWeight: 600 }}>
							Pago de la tasacion
						</Text>
						<Text style={{ color: '#748EA0', fontSize: 14, fontWeight: 400 }}>
							Descripcion si la hay
						</Text>
					</Col>
					<Col span={12}>
						<Text style={{ color: '#748EA0', fontSize: 14, fontWeight: 600 }}>
							{numeral(mortgage?.operationData?.mortgage?.appraisalAmount).format('0,0.00 $')}
						</Text>
						<Button
							onClick={() => setShowCheckout(!showCheckout)}
							className="button-primari-gibobs"
							style={{ width: 'auto', height: 40, marginLeft: 24, borderRadius: 8 }}>
							Pagar
						</Button>
					</Col>
				</Row>
			)*/}

			{mortgage && (
				<CheckOutComponent
					userMortgageId={operationId}
					amount={mortgage?.operationData?.mortgage?.appraisalAmount}
					showPayBoolean={showCheckout}
					mortgageId={operationId}
					clientSecretToken={dataClient?.paymentSeat?.session?.client_secret}
					dataClient={dataClient}
					firtsPaydocuments={true}
					setshowCheckout={setShowCheckout}
					setModalPay={undefined}
					getDataOperation={getDataOperation}
				/>
			)}

			<div style={{ position: 'absolute', bottom: 16, left: 16 }}>
				<div style={{ marginBottom: 0 }}>
					<Divider type="horizontal" style={{ color: '#C0DAEE' }}></Divider>
				</div>
				<div style={{ display: 'flex', flexDirection: 'column' }}>
					<div>
						<LockOutlined style={{ color: '#748EA0', fontSize: 22 }} />
						<Text style={{ fontSize: 12, fontWeight: 400, color: '#748EA0', marginLeft: 8 }}>
							{t('doc.ourSecureInformation').replace(/:$/, '.')}
						</Text>
					</div>

					<div style={{ display: 'flex', marginTop: 2 }}>
						<div>
							<img src={protectedPayment} width={22} />
						</div>
						<div>
							<Text
								style={{
									fontSize: 12,
									fontWeight: 400,
									color: '#748EA0',
									marginLeft: 8
								}}>
								{t('appraisal.protectedPayment')}
							</Text>
						</div>
					</div>
				</div>
			</div>
		</Layout>
	);
}

export default Payments;
